import React from 'react';
export interface ModalConfiguration {
    content?: JSX.Element | null;
    defaultButtonMessage?: string;
    defaultButtonAction?: any;
    buttons?: JSX.Element;
    isOpen?: boolean;
    toggle?: any;
}

const Modal = ({ content, defaultButtonMessage = 'OK', defaultButtonAction, buttons, isOpen = false, toggle }: ModalConfiguration) => {
    const toggleModal = () => {
        toggle();
    };

    const defaultAction = () => {
        if (defaultButtonAction) {
            defaultButtonAction();
        }
        toggleModal();
    };

    if (!isOpen) {
        return null;
    }
    return (
        <div id='modal' className='modal-overlay' onClick={toggleModal}>
            <div className='bs-modal-body' onClick={e => e.stopPropagation()}>
                <div className='bs-modal-content'>{content}</div>
                <div className='modal-buttons'>
                    {buttons}
                    <button className='close-btn' onClick={defaultAction}>
                        {defaultButtonMessage}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default Modal;
